module.exports = __webpack_public_path__ + "static/media/tomatoe-bulbs.1c7f91f7.PNG";